// extracted by mini-css-extract-plugin
export var contentBody = "_ai-9";
export var headerImage = "_ai-2";
export var imageButton = "_ai-7";
export var imageButtonIcon = "_ai-8";
export var imageHeader = "_ai-4";
export var imageHeaderText = "_ai-5";
export var imageOverlay = "_ai-3";
export var imageTitle = "_ai-6";
export var imageWrapper = "_ai-1";
export var taskList = "_ai-a";
export var widget = "_ai-0";